//------------------
// set item values
//------------------
export default function setItemValues() {
  // console.log('----------------------------')
  // console.log('IN setItemValues')
  // -----------------
  // define structure
  // -----------------
  let item = {
    // text fields
    type: '',
    equipment_type: 'n/a',
    name: '',
    description: '',
    short_description: '',
    player_notes: '',
    //
    // default lookup-based fields for artefacts/items
    artefact_type: '',
    artefact_base_item: null,
    item_size: null,
    container_size: null,
    quality: 'Unknown',
    age: 'Unknown',
    material: 'Unknown',

    // actual values
    enc: 0.1,
    tot_enc: 0.1,
    tally_qty: 1,

    // zero values
    id: 0,
    contents_enc: 0,
    contents_count_direct: 0,
    currency_cost: 0,
    hp: 0,
    ap: 0,
    range: 0,
    damage_dice: 0,
    load: 0,
    str_cur: 0,
    dex_cur: 0,
    value_lower: 0,
    value_upper: 0,
    pwr_storage: 0,
    container_capacity: null,
    container_size_short: '',
    container_size_long: '',

    // false values
    active: false,
    worn: false,
    stored: false,
    equipped: false,
    starter: false,
    wearable: false,
    storage: false,
    attachable: false,
    attach_point: false,
    broken: false,
    countable: false,
    campaign: false,
    tallyable: false,
    storeable: false,

    // default booleans that are later sourced from the selected static item
    // or selected artefact type
    estimated_value: true,

    // arrays
    races: [],
    currencies: [],
    runes: [],
    non_runes_spells: [],
    skills: [],
    units: [],

    // selection objects
    container: null,
    worn_location: null,
    attach_location: null,
    race: null,
    currency: null,
    image: null,
    image_file: null,
  }
  return item
}
